import { MatDialogRef } from '@angular/material';
var FirmwareUpdateDialogComponent = /** @class */ (function () {
    function FirmwareUpdateDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.dontShowAgain = false;
    }
    FirmwareUpdateDialogComponent.prototype.close = function () {
        this.dialogRef.close(this.dontShowAgain);
    };
    return FirmwareUpdateDialogComponent;
}());
export { FirmwareUpdateDialogComponent };
